import { useEffect, useState } from 'react'
import { followUpApi } from 'services/results/follow-up'

export default function ProfileHistory({ processId }: { processId: number }) {
  const [versions, setVersions] = useState<any[]>([])
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    let active = true
    followUpApi(processId, 'history')
      .then((data) => {
        if (active) setVersions(data)
      })
      .catch(() => {
        if (active) setError('No se pudo cargar el historial de perfiles ideales.')
      })
      .finally(() => {
        if (active) setLoading(false)
      })
    return () => {
      active = false
    }
  }, [processId])
  return (
    <section style={{ margin: '24px 0', width: '100%' }} aria-label="Historial de perfiles ideales">
      <h3>Historial del perfil ideal · 3D Skills</h3>
      <p>
        Las versiones documentan los objetivos utilizados en cada medición. Las referencias anteriores al inicio del
        historial pueden no estar disponibles.
      </p>
      {loading && <p>Cargando historial…</p>}
      {error && <p role="alert">{error}</p>}
      {!loading && !error && !versions.length && <p>Aún no hay versiones registradas.</p>}
      {versions.map((version, index) => {
        const previous = versions[index + 1]
        return (
          <details key={version.id} style={{ borderBottom: '1px solid #ddd', padding: 12 }}>
            <summary>
              Versión {version.id} · {new Date(version.changed_at).toLocaleString('es-CO')} ·{' '}
              {version.author?.trim() || 'Autor no registrado'}
              {index === 0 ? ' · Vigente registrada' : ''}
            </summary>
            {!version.historical_reference && (
              <p>Registro de referencia al iniciar el historial; la fecha no acredita la modificación original.</p>
            )}
            <table style={{ width: '100%', textAlign: 'left', marginTop: 12 }}>
              <thead>
                <tr>
                  <th>Competencia</th>
                  <th>Objetivo anterior</th>
                  <th>Objetivo de esta versión</th>
                </tr>
              </thead>
              <tbody>
                {version.competences.map((c: any) => (
                  <tr key={c.type_category_test_id}>
                    <td>{c.name}</td>
                    <td>
                      {previous?.competences.find((p: any) => p.type_category_test_id === c.type_category_test_id)
                        ?.weight ?? 'No disponible'}
                    </td>
                    <td>{c.weight}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </details>
        )
      })}
    </section>
  )
}
